// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2vtxq","title":"AfterBackImages_title__23OHq","images":"AfterBackImages_images__10JCy"};